"use client";
import ToolsStack from "@/components/section-infographic/DesignAndDevelopmentAsAService/ToolsStack";
import CaseStudiesMutiPurposeZigZagSection from "@/components/ui/CaseStudiesMutiPurposeZigZagSection";
import CaseStudyEngageMentModel from "@/components/ui/CaseStudyEngageMentModel";
import CommentSection from "@/components/ui/CommentSection";
import CTABanner from "@/components/organisms/CTABanner";
import VideoSection from "@/components/ui/VideoSection";

import CaseStudiesIntroBanner from "@/components/ui/CaseStudiesIntroBanner";
import CaseStudiesNewMegaCardSection from "@/components/ui/CaseStudiesNewMegaCarSection";
import CaseStudiesSkewSatusCardsSection from "@/components/ui/CaseStudiesSkewSatusCardsSection";
import ImageMarquee from "@/components/ui/ImageMarquee";
import SectionTitle from "@/components/ui/SectionTitle";
import IndustryHero from "@/components/SectionHero/IndustryHero";

import RelatedCaseStudies from "@/components/ui/RelatedCaseStudies";
import UniversalTable from "@/components/UniversalTable";
import TheChallengeScrollSection from "@/components/ui/TheChallengeScrollSection";
import RedRibbonBanner from "@/components/ui/RedRibbonBanner";

export default function BoardGamesCasestudyPage() {
    const clients = [

        {
            label: "CLIENT",
            name: "Precise Portions",

        },
        {
            label: "INDUSTRY",
            name: "Health & Wellness / Nutrition / Diabetes-Friendly Meal Planning",

        },
        {
            label: "Engagement Type",
            description: "Social Media Marketing, Organic Growth & Community Building",
        },
    ];

    const skewCards = [
        {
            title: "60%",
            description: "People Engaged",
        },
        {
            title: "30%",
            description: "Organic Traffic Growth",
        },
        {
            title: "60%",
            description: "Facebook and Instagram Engagement Growth",
        },
        {
            title: "40%",
            description: "Follower Growth",
        },
    ];

    return (
        <main className="overflow-hidden">

            <IndustryHero svgPath="/HeroSectionImg/PrecisePortions.svg" />
            <CaseStudiesIntroBanner
                title="How Precise Portions Built a Health-Focused Digital Community with 60% Higher Engagement"
                subtitle=""
                imageSrc="/logo/PrecisePortions.svg"
                imageAlt="Board Games"
            />

            <CaseStudiesSkewSatusCardsSection clients={clients} skewCards={skewCards} clientIntroPara="Precise Portions, a nutrition learning system created to make healthy eating easier, needed to build brand awareness, drive website traffic, maximize leads, and grow a stronger digital community around its mission.
MMB supported Precise Portions with a community-led social and organic growth strategy focused on awareness, education, engagement, and audience trust." />

            <section className=" relative overflow-hidden border-y border-[#EDEDED] ">
                < VideoSection src="/video/PrecisePortion.mp4" poster="/Thumbnails/PrecisePortions.png" />
            </section>



            <TheChallengeScrollSection
                sectionTitle={{
                    title: "The Challenge",
                    description: [
                        "Precise Portions had a meaningful product and a clear health-focused mission, but needed stronger digital visibility to reach the right audience. The brand wanted to build awareness, achieve better ROI, maximize leads, build a community and drive more website traffic.",
                        "The challenge was to communicate nutrition education in a way that felt practical, trustworthy, and accessible while also improving engagement across Facebook, Instagram, and organic channels.",
                        "For a brand operating in the health and nutrition space, visibility alone was not enough. The strategy needed to build credibility, encourage interaction, and create a community around better eating habits."
                    ],
                }}
                rightColumnItems={[
                    {
                        heading: "Limited Brand Awareness",
                        text: "Weak visibility among people looking for practical nutrition support, portion control, and diabetes-conscious eating solutions.",
                    },
                    {
                        heading: "Trust-Building Requirement",
                        text: "Because the brand was connected to health education, the messaging needed to feel credible, helpful, and non-generic.",
                    },
                    {
                        heading: "Need for Community-Led Growth",
                        text: "Strong emotional relevance, but the brand’s digital channels needed to convert that story into an active, engaged community.",
                    },
                    {
                        heading: "Low Organic Traffic Opportunity",
                        text: "The website needed more qualified visitors from organic and social channels to support lead generation & brand discovery.",
                    },
                    {
                        heading: "Engagement Gap Across Social Platforms",
                        text: "Facebook & Instagram needed stronger content consistency, sharper messaging, and audience-focused creative direction.",
                    },
                    {
                        heading: "Lead Generation Gap",
                        text: "The brand needed to use content and community engagement to move users from awareness to potential leads.",
                    },

                ]}
            />
            <div className=" py-16 lg:py-24  relative overflow-hidden">

                <CaseStudiesMutiPurposeZigZagSection
                    sectionTitle="Our Strategic Approach"
                    sectionDescription="MMB built a community-first growth strategy focused on turning Precise Portions’ health mission into consistent digital engagement. The goal was to help Precise Portions become more visible, more trusted, and more engaging across digital touchpoints. "

                    cards={[
                        {
                            iconSrc: "/icons/StrategicApproach-icon/PrecisePortions (6).svg",
                            iconAlt: "Community Growth",
                            title: "Community Growth",
                            description: "Built content and engagement loops designed to grow an audience around healthy eating, nutrition education and portion-control awareness.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/PrecisePortions (3).svg",
                            iconAlt: "Awareness-to-Engagement",
                            title: "Awareness-to-Engagement",
                            description: "Created messaging that moved users from passive awareness to active interaction with the brand.",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/PrecisePortions (1).svg",
                            iconAlt: "Organic Traffic Growth",
                            title: "Organic Traffic Growth",
                            description: "Used content direction and platform optimization to support website visits and organic discovery.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/PrecisePortions (4).svg",
                            iconAlt: "Social Engagement",
                            title: "Social Engagement",
                            description: "Focused on improving Facebook and Instagram engagement through relevant, helpful and visually accessible content.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/PrecisePortions (2).svg",
                            iconAlt: "Lead Nurturing",
                            title: "Lead Nurturing",
                            description: "Used social content and website traffic pathways to support lead generation opportunities.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/PrecisePortions (5).svg",
                            iconAlt: "Optimization Lifecycle",
                            title: "Optimization Lifecycle",
                            description: "Tracked audience response, engagement patterns, follower growth and traffic movement to refine the campaign direction.",
                        },
                    ]}
                />

            </div>

            <div className="custom-container pb-16 lg:pb-20 xl:pb-24">


                <CaseStudyEngageMentModel
                    leftImage="/hero-bg/officemeet.jpg"
                    cards={[
                        {
                            title: "Organic Growth & Community Building Engagement",
                            description: [
                                "A focused engagement designed to improve brand awareness, social engagement, organic traffic, and follower growth.",
                            ],
                        },
                        {
                            title: "Dedicated Growth Pod",
                            description: [
                                "Social media strategist, content planner, creative resource, engagement specialist, and performance analyst.",
                            ],
                        },
                        {
                            title: "Optimization Rhythm",
                            description: [
                                "Audience engagement, social performance, organic traffic, follower growth, and lead opportunities were reviewed regularly to guide improvements.",
                            ],
                        },
                        {
                            title: "Community Layer",
                            description: [
                                "Content was shaped to educate, engage, and build trust with users looking for better nutrition habits and healthier eating support.",
                            ],
                        },
                    ]}

                />
            </div>


            <div className="section-background-filler py-16 space-y-16">
                <CaseStudiesNewMegaCardSection
                    sectionTitle={{
                        title: "What We Did ",
                        description: "We created a community-led growth strategy to improve brand awareness, increase engagement, drive website traffic, and build trust around nutrition education. ",
                        align: "left"
                    }}
                    cards={[
                        {
                            title: "Brand Positioning",
                            description:
                                "Strengthened Precise Portions’ digital messaging around healthy eating, portion control, and nutrition support.",
                        },
                        {
                            title: "Content Strategy",
                            description:
                                "Developed a content direction focused on education, awareness, community building, and website traffic.",
                        },
                        {
                            title: "Social Media Execution",
                            description:
                                "Created platform-focused content for Facebook and Instagram to improve reach and interaction.",
                        },
                        {
                            title: "Community Building",
                            description:
                                "Built engagement-led content loops to encourage audience participation and brand recall.",
                        },
                        {
                            title: "Organic Growth Support",
                            description:
                                "Used content and social visibility to increase organic traffic to the website.",
                        },
                        {
                            title: "Lead-Focused Messaging",
                            description:
                                "Created messaging pathways designed to move users from social engagement to website visits.",
                        },
                        {
                            title: "Visual Content Direction",
                            description:
                                "Used food, nutrition, and healthy lifestyle visuals to make the brand more relatable and engaging.",
                        },
                        {
                            title: "Performance Optimization",
                            description:
                                "Monitored engagement, follower growth, organic traffic, and social response to refine the campaign.",
                        },
                    ]}

                />

                <div className="mb-12 px-6 md:px-auto xl:my-12">
                    <RedRibbonBanner title="Key Insight:">
                        Precise Portions did not need generic health content. It needed content that made nutrition feel easier, more practical, and more personal for people trying to make better food decisions.
                    </RedRibbonBanner>
                </div>


                <ImageMarquee
                    images={[
                        { src: "/CaseStudiesFolder/ShowCaseImg/preciseportions-ShowCaseImages/ShowCaseImg (2).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/preciseportions-ShowCaseImages/ShowCaseImg (1).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/preciseportions-ShowCaseImages/ShowCaseImg (3).png", alt: "Jem Jem case study" },
                    ]}
                    speed={20}
                    direction="left"
                    pauseOnHover={false}
                />


            </div>



            <section className="py-16 lg:py-20 custom-container">
                <SectionTitle
                    title="The Results "
                    description="The campaign helped Precise Portions improve social engagement, grow its follower base, and drive stronger organic traffic."
                    align="center"
                    highlightSubtitle={true}
                />


                <div className="w-full overflow-x-auto mt-6">
                    <div className="inline-block min-w-full align-middle">
                        <div className="grid grid-cols-1  gap-6 !text-left ">




                            <UniversalTable
                                title="Growth Impact"
                                headers={["Metric", "Result"]}
                                rows={[
                                    [
                                        "People Engaged",
                                        "60% increase",
                                    ],
                                    [
                                        "Organic Traffic",
                                        "30% growth",
                                    ],
                                    [
                                        "Facebook & Instagram Engagement",
                                        "60% growth",
                                    ],
                                    [
                                        "Followers Growth",
                                        "40% growth",
                                    ],
                                    [
                                        "-",
                                        "-",
                                    ],
                                ]}
                                ribbonTitle="Key Insight"
                                ribbonContent="By turning the brand’s purpose into consistent, audience-first content, MMB helped Precise Portions create stronger engagement across social channels."
                            />

                            <UniversalTable
                                title="Channel Impact"
                                headers={["Channel / Focus Area", "Business Role"]}
                                rows={[
                                    [
                                        "Facebook",
                                        "Improved community interaction, content reach, and audience engagement.",
                                    ],
                                    [
                                        "Instagram",
                                        "Supported visual storytelling, nutrition awareness, and follower growth.",
                                    ],
                                    [
                                        "Organic Traffic",
                                        "Helped bring more users to the website through content-led discovery.",
                                    ],
                                    [
                                        "Community Content",
                                        "Built stronger emotional relevance around healthy eating and portion control.",
                                    ],
                                    [
                                        "Engagement Optimization",
                                        "Improved how users interacted with the brand across social channels.",
                                    ],
                                ]}
                                ribbonTitle="Key Insight"
                                ribbonContent="By aligning different focus areas, we built a connected digital ecosystem where social visibility translated into stronger community interaction and follower growth."
                            />

                          
                                <UniversalTable
                                    title="The Impact"
                                    headers={["Growth Area", "Impact Delivered"]}
                                    rows={[
                                        [
                                            "Brand Awareness",
                                            "Improved visibility for a purpose-led nutrition brand.",
                                        ],
                                        [
                                            "Audience Engagement",
                                            "60% increase in people engaged.",
                                        ],
                                        [
                                            "Organic Growth",
                                            "30% increase in organic traffic.",
                                        ],
                                        [
                                            "Social Media Performance",
                                            "60% growth in Facebook and Instagram engagement.",
                                        ],
                                        [
                                            "Community Building",
                                            "Stronger audience interaction around healthy eating and nutrition learning.",
                                        ],
                                        [
                                            "Follower Growth",
                                            "40% increase in followers.",
                                        ],
                                        [
                                            "Lead Potential",
                                            "Increased website traffic and improved audience pathways from social to site.",
                                        ],
                                    ]}
                                    ribbonTitle="Key Insight"
                                    ribbonContent="MMB helped Precise Portions move from simple brand visibility to a stronger community-led growth model where people could discover, engage with, and trust the brand’s nutrition mission."
                                />
                        </div>
                    </div>
                </div>

            </section>





            <CommentSection quote="Our goal was to build awareness around healthy eating while growing an engaged online community. MMB understood our mission from day one and created a content strategy that increased engagement, expanded our reach, and brought more people to our website." name="Precise Portions" avatarSrc={""} />

            <ToolsStack
                title="Our Tech Stack & Tools "
                description="Our strategy combined social media, content planning, analytics, and community management tools to build engagement and strengthen organic reach.  "
                categories={[
                    {
                        title: "Organic Growth",
                        items: [
                            "Social-to-website traffic optimization",
                            "engagement-led content distribution",
                            "audience targeting insights",
                        ],
                    },
                    {
                        title: "Performance Tracking",
                        items: [
                            "Engagement tracking",
                            "Follower growth monitoring",
                            "Organic traffic tracking",
                            "social analytics"
                        ],
                    },
                    {
                        title: "Reporting & Collaboration",
                        items: [
                            "Google Sheets",
                            "Google Drive",
                            "Campaign reporting dashboards",
                        ],
                    },
                    {
                        title: "Content Strategy",
                        items: [
                            "Content calendar planning",
                            "Audience research",
                            "Nutrition-focused messaging",
                            "Community engagement planning",
                        ],
                    },
                    {
                        title: "Creative Direction",
                        items: [
                            "Food visuals",
                            "Healthy lifestyle content",
                            "Educational creatives",
                            "Product-led storytelling",
                        ],
                    },
                    {
                        title: "Social Media Platforms",
                        items: [
                            "Facebook",
                            "Instagram",
                           
                        ],
                    },
                ]}
                withBackground={true}
            />


            <div className="pb-0 md:pb-16 xl:pb-20 relative overflow-hidden">
                <CTABanner
                    title="Build a brand people trust, follow, and engage with."
                    description="Let MMB create your next growth engine."
                    buttonText="Book a Growth Consultation Session"
                  
                    bgColor="#313866"
                    textColor="#fff"
                    buttonVariant="primary"
                />
            </div>
            <RelatedCaseStudies />
        </main >
    );
}